import {PreviewBuilderModel, PreviewerLinkTypesEnum} from '../../../models/api/previewerModel';
import {ConditionAction} from '../conditions/conditionsActions';
import {ExpressionAction} from '../expressions/expressionActions';
import {PreviewerEditorState} from './previewerEditorState';

/*
 * Type enum.
 */

export enum PreviewerEditorActionTypesEnum {
  UPDATE_LINK_TYPE = '@@previewer/UPDATE_LINK_TYPE',
  UPDATE_DOMAIN = '@@previewer/UPDATE_DOMAIN',
  UPDATE_DESCRIPTION = '@@previewer/DESCRIPTION',
  UPDATE_EXAMPLE_URL = '@@previewer/UPDATE_EXAMPLE_URL',
  START_REQUEST_EXPRESSION = '@@previewer/START_REQUEST_EXPRESSION',
  UPDATE_PREVIEW_BUILDER = '@@previewer/UPDATE_PREVIEW_BUILDER',
}

/*
 * Types.
 */

interface UpdatePreviewerLinkType {
  type: PreviewerEditorActionTypesEnum.UPDATE_LINK_TYPE;
  linkType: PreviewerLinkTypesEnum;
}

interface UpdatePreviewerDomain {
  type: PreviewerEditorActionTypesEnum.UPDATE_DOMAIN;
  domain: string;
}

interface UpdatePreviewerDescription {
  type: PreviewerEditorActionTypesEnum.UPDATE_DESCRIPTION;
  description: string;
}

interface UpdatePreviewerExampleUrl {
  type: PreviewerEditorActionTypesEnum.UPDATE_EXAMPLE_URL;
  exampleUrl: string | undefined;
}

interface StartRequestExpression {
  type: PreviewerEditorActionTypesEnum.START_REQUEST_EXPRESSION;
}

interface UpdatePreviewBuilder {
  type: PreviewerEditorActionTypesEnum.UPDATE_PREVIEW_BUILDER;
  previewBuilder: PreviewBuilderModel;
}

/*
 * Combined action type.
 */

export type PreviewerEditorAction =
  | UpdatePreviewerLinkType
  | UpdatePreviewerDomain
  | UpdatePreviewerDescription
  | UpdatePreviewerExampleUrl
  | StartRequestExpression
  | UpdatePreviewBuilder
  | ExpressionAction<PreviewerEditorState>
  | ConditionAction;
